export const lightTheme = {
  colors: {
    primary: '#635bff',
    secondary: '#7c3aed',
    success: '#16a34a',
    error: '#dc2626',
    background: '#ffffff',
    surface: '#f8fafc',
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
      inverse: '#ffffff'
    },
    border: 'rgba(79, 70, 229, 0.1)',
    gradient: {
      primary: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
      surface: 'radial-gradient(circle at 0% 0%, rgba(79, 70, 229, 0.03) 0%, transparent 50%)'
    }
  },
  shadows: {
    sm: '0 2px 8px rgba(79, 70, 229, 0.07)',
    md: '0 4px 20px rgba(79, 70, 229, 0.1)',
    lg: '0 8px 30px rgba(79, 70, 229, 0.15)'
  },
  transitions: {
    default: 'all 0.3s ease',
    smooth: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
  },
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '24px',
    full: '9999px'
  },
  typography: {
    fontFamily: "'Urbanist', sans-serif",
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem'
    }
  }
};

export const darkTheme = {
  ...lightTheme,
  colors: {
    primary: '#6366f1',
    secondary: '#8b5cf6',
    success: '#22c55e',
    error: '#ef4444',
    background: '#0f172a',
    surface: '#1e293b',
    text: {
      primary: '#f8fafc',
      secondary: '#94a3b8',
      inverse: '#0f172a'
    },
    border: 'rgba(148, 163, 184, 0.1)',
    gradient: {
      primary: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
      surface: 'radial-gradient(circle at 0% 0%, rgba(99, 102, 241, 0.1) 0%, transparent 50%)'
    }
  },
  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.3)',
    md: '0 4px 20px rgba(0, 0, 0, 0.4)',
    lg: '0 8px 30px rgba(0, 0, 0, 0.5)'
  }
};
